const AboutStory = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/4d62ec3e65afc0b50b8670812bad819e.jpeg"
                alt="Pastor Don R. Vining"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#D4AF37] rounded-full opacity-20 blur-3xl"></div>
          </div>

          {/* Content */}
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wider mb-5">(His Calling)</p>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-6 leading-tight">
              A Journey of Faith and Service
            </h2>
            
            <div className="space-y-5 text-base text-gray-700 leading-relaxed">
              <p>
                For over 35 years, Pastor Don R. Vining has faithfully served as a shepherd to God's people. His journey began with a profound calling to ministry in his early twenties, leading him to pursue theological education and dedicate his life to teaching the Word of God.
              </p>
              <p>
                Throughout his pastoral ministry, Pastor Don has witnessed countless lives transformed by the power of Scripture. His heart for discipleship and spiritual growth led him to begin writing, creating resources that would extend his ministry beyond the walls of the church and into the homes and hearts of believers everywhere.
              </p>
              <p>
                As an author, Pastor Don combines deep biblical knowledge with practical wisdom gained from decades of pastoral care. His books reflect his genuine desire to help readers develop a closer relationship with Christ, navigate life's challenges with faith, and discover the abundant life God promises.
              </p>
              <p>
                Don R. Vining is a minister and entrepreneur with over forty-five years of combined ministry and business experience. He has planted churches, mentored leaders, and faithfully served in advancing the Kingdom of God. A credentialed minister with the Church of God (Cleveland, Tennessee), Don has been recognized for twenty-five years of service and holds an Honorary Doctor of Ministry degree from Jacksonville Theological Seminary. He lives in Belleview, Florida, with his family, continuing his passion for helping others grow in faith and fulfill God's purpose for their lives.
              </p>
            </div>

            <div className="mt-8 pl-6 border-l-4 border-[#D4AF37]">
              <p className="text-lg italic text-gray-600 font-serif">
                "My prayer is that these words bring you closer to the heart of God and help you walk confidently in His purpose for your life."
              </p>
              <p className="text-base font-bold text-[#1B3A52] mt-3">— Pastor Don Vining</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
